import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

import WebViewer from "@pdftron/webviewer";
import FadeLoader from "react-spinners/FadeLoader";

import toast from "@safecv/shared/toast";
import { Launcher } from "@safecv/feedback";
import MESSAGE from "@safecv/shared/message";
import SidebarToAnnotationLine from "./SidebarToAnnotationLine";
import StampModalComponent from "../HeaderComponent/StampModalComponent";

import moment from "moment";
import API from "@safecv/api";
import { template } from "lodash";
import {
  PDFTRON_LICENSE_KEY,
  TOKEN_SESSION_ATTRIBUTE_NAME,
} from "@safecv/shared/appConstant";
import API_CONFIG from "@safecv/src/api-config";
import { handleURLChange } from "@safecv/shared/urlParams";

import {
  addFeedback,
  addAnnotation,
  modifyAnnotation,
  getStandardStamps,
  getFullAnnotationXfdf,
  postFullAnnotationXfdf,
  discardRestoreAnnotation,
  favouriteAnnotation,
} from "@safecv/actions/postActions";
import {
  stampEndorsementStarted,
  stampEndorsementSuccess,
} from "./../../../Actions/types";
import { override } from "@safecv/shared/sharedFunction";

import stampIcon from "@safecv/assets/Images/multiple_pages_stamp.svg";
import favouriteIcon from "@safecv/assets/Images/favourite.svg";
import favouriteMarked from "@safecv/assets/Images/favouriteMarked.svg";

import "./PDFViewer.css";

var updateFuntion = null;

const PDFViewer = (props) => {
  //props received from parent component can be used
  const {
    jobId,
    viewType,
    isPdfSelected,
    pageNumber,
    selectedAnnotation,
    addAnnotation,
    modifyAnnotation,
    loading,
    discardRestoreAnnotation,
    annotationPayload,
    selectedAnnotationUuid,
    searchPayload,
    selectedSearchResult,
    planStatus,
    postFullAnnotationXfdf,
    feedback,
    restoredAnnotationId,
    isDocumentSelected,
    setRestoredAnnotationId,
    getFullAnnotationXfdf,
    getxfdfData,
    selectedReconciliation,
    selectedStampDocument,
    stampendorsementLoading,
    stampEndorsementSuccess,
    selectedEnhancedSearch,
    selectedGroupEnhancedSearch,
    sidebarRef,
    annotationRefs,
    isReconciliationSidebarOpen,
    isPossibleEvidenceModalClose,
    setViewType,
    setSelectedStampDocument,
    isSidebarOpen,
    favouriteAnnotations,
    makeAnnotationFavourite,
  } = props;

  const viewer = useRef(null);
  const pdfViewerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [instance, setInstance] = useState(null);
  const [annotManager, setAnnotManager] = useState(null);
  const [docViewer, setDocViewer] = useState(null);
  const [annotationUuid, setAnnotationUuid] = useState(null);
  const [fullXFDF, setFullXFDF] = useState(null);
  const [addedAnnotationString, setAddedAnnotationString] = useState(null);
  const [resultSet, setResultSet] = useState([]);
  const [feedbackList, setFeedbackList] = useState([]);
  const [modifiedAnnotationString, setModifiedAnnotationString] = useState(
    null
  );
  const [deletedAnnotationString, setDeletedAnnotationString] = useState(null);
  const [annotation, setAnnotation] = useState(null);
  const [showLine, setShowLine] = useState(false);
  const [fullScreenButton, setFullScreenButton] = useState(false);
  const [pageTransition, setPageTransition] = useState("Continuous");
  const [pageLayout, setPageLayout] = useState("SinglePage");
  const [zoomLevel, setZoomLevel] = useState(null);
  const [isStampModalOpen, setIsStampModalOpen] = useState(false);
  const [stampMultiAnnot, setStampMultiAnnot] = useState(null);
  const [addRemoveFav, setAddRemoveFav] = useState(null);
  const [freeTextAnnot, setFreeTextAnnot] = useState(null);
  const [stampTabActive, setStampTabActive] = useState(true);
  const [selectedFavAnnotId, setSelectedFavAnnotId] = useState(null);

  const parser = new DOMParser();
  const stampToolName = "AnnotationCreateCustomStamp";
  const freeTextToolName = "AnnotationCreateCustomFreeText";

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getAnnotation = () => {
    handleClickOpen();
  };

  // to get the annotation id from annotationList, for selected annotation on plan
  const getAnnotationIdToBeProcessed = () => {
    let annotaionData = annotationPayload.filter(
      (annotation) => annotation.annotationName === annotationUuid
    );
    let id = annotaionData.length && annotaionData[0].id;
    return id;
  };

  const deleteAnnotFromPDF = (uuid) => {
    annotManager.deleteAnnotation(annotManager.getAnnotationById(uuid));
    fullXFDFSetter(annotManager);
  };

  const deleteAnnotation = (textvalue, selectedValue) => {
    let id = getAnnotationIdToBeProcessed();
    if (id) {
      // api call
      discardRestoreAnnotation(
        jobId,
        id,
        viewType,
        true,
        selectedValue === "None of the above" ? textvalue : selectedValue
      );
      deleteAnnotFromPDF(annotationUuid);
    }
    handleClose();
  };

  const fullXFDFSetter = (annotManager) => {
    annotManager.exportAnnotations().then((xfdfString) => {
      setFullXFDF(xfdfString);
    });
  };

  const constructQuads = (rotation, pageNo, highlightValue, docViewer) => {
    var width, height, quads;
    if (rotation === 0) {
      width = docViewer.getPageWidth(pageNo);
      height = docViewer.getPageHeight(pageNo);
      quads = [
        {
          x1: highlightValue[0][0],
          y1: height - highlightValue[0][1],
          x2: highlightValue[1][0],
          y2: height - highlightValue[0][1],
          x3: highlightValue[1][0],
          y3: height - highlightValue[1][1],
          x4: highlightValue[0][0],
          y4: height - highlightValue[1][1],
        },
      ];
    } else if (rotation === 1) {
      width = docViewer.getPageHeight(pageNo);
      height = docViewer.getPageWidth(pageNo);
      quads = [
        {
          y1: width - highlightValue[0][0],
          x1: height - highlightValue[0][1],
          y2: width - highlightValue[1][0],
          x2: height - highlightValue[0][1],
          y3: width - highlightValue[1][0],
          x3: height - highlightValue[1][1],
          y4: width - highlightValue[0][0],
          x4: height - highlightValue[1][1],
        },
      ];
    } else if (rotation === 2) {
      width = docViewer.getPageWidth(pageNo);
      height = docViewer.getPageHeight(pageNo);
      quads = [
        {
          x1: width - highlightValue[0][0],
          y1: highlightValue[0][1],
          x2: width - highlightValue[1][0],
          y2: highlightValue[0][1],
          x3: width - highlightValue[1][0],
          y3: highlightValue[1][1],
          x4: width - highlightValue[0][0],
          y4: highlightValue[1][1],
        },
      ];
    } else if (rotation === 3) {
      width = docViewer.getPageHeight(pageNo);
      height = docViewer.getPageWidth(pageNo);
      quads = [
        {
          y1: highlightValue[0][0],
          x1: highlightValue[0][1],
          y2: highlightValue[1][0],
          x2: highlightValue[0][1],
          y3: highlightValue[1][0],
          x3: highlightValue[1][1],
          y4: highlightValue[0][0],
          x4: highlightValue[1][1],
        },
      ];
    }
    return quads;
  };

  const createSearchSet = (
    highlightValue,
    pageNo,
    id,
    message,
    rotation,
    docViewer
  ) => {
    var quads = constructQuads(rotation, pageNo, highlightValue, docViewer);
    return {
      id: id || "",
      ambientStr: message || "",
      ambient_str: message || "",
      pageNum: pageNo,
      page_num: pageNo,
      quads: quads,
      resultCode: 2,
      resultStr: "recently",
      resultStrEnd: -1,
      resultStrStart: -1,
      result_str: "recently",
      result_str_end: -1,
      result_str_start: -1,
    };
  };

  const searchHighlight = (searchPayload, docViewer) => {
    var resultSet = [];
    searchPayload.map((item) => {
      var rotation = docViewer.getCompleteRotation(item.pageNo);
      resultSet.push(
        createSearchSet(
          item.fscoordinates,
          item.pageNo,
          item.id,
          item.annotationSpecificMessage,
          rotation,
          docViewer
        )
      );
    });
    setResultSet(resultSet);
    docViewer.displayAdditionalSearchResults(resultSet);
    docViewer.setActiveSearchResult(resultSet[0]);
  };

  const createDynamicStamp = (ctx, Width, Height, stampMetadata, userInput) => {
    const today = new Date();
    const dataObj = {
      currentDate: moment(today).format("MM/DD/YYYY"),
      currentTime: moment(today).format("HH:mm"),
    };
    const width = Width;
    const height = Height;
    const {
      lineWidth,
      textContent,
      strokeStyle,
      rectX,
      rectY,
      padding,
      defaultTextStyles,
      textY,
      lineHeight,
      showPrompt,
      userVariableKey,
    } = stampMetadata;

    //Getting value from reviewer for user's name
    if (showPrompt && userInput !== null && userInput !== undefined) {
      var key = userVariableKey;
      dataObj[key] = userInput;
    }

    //Creating new background with transparency and putting it instead of existing image
    const img = ctx.createImageData((Width * 300) / 96, (Height * 300) / 96);
    for (let i = img.data.length; --i >= 0; ) {
      img.data[i] = 0;
    }
    ctx.putImageData(img, 1, 1);

    // Drawing a border around the rect
    ctx.beginPath();
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = strokeStyle;
    ctx.rect(rectX, rectY, width - padding, height - padding);
    ctx.stroke();

    // Drawing text insode the rect
    let j = 0;
    textContent.forEach((d) => {
      ctx.fillStyle = d.fontColor ? d.fontColor : defaultTextStyles.fontColor;
      ctx.textAlign = d.textAlign ? d.textAlign : defaultTextStyles.textAlign;
      ctx.font = d.fontStyle
        ? `${d.fontWeight} ${d.fontSize} ${d.fontStyle}`
        : `${defaultTextStyles.fontWeight} ${defaultTextStyles.fontSize} ${defaultTextStyles.fontStyle}`;
      var x;
      if (d.textAlign === "left") {
        x = 12;
      } else {
        x = width / 2;
      }
      var y = textY;
      var lineheight = lineHeight;
      var lines = d.text;
      var templateStr = template(lines);
      var compiled = templateStr(dataObj);
      if (d.wrap) {
        wrapText(ctx, compiled, x, y + j * lineheight, width - 20, lineheight);
      } else {
        ctx.fillText(compiled, x, y + j * lineheight);
      }
      if (d.underline) {
        textUnderline(
          ctx,
          compiled,
          x,
          y + j * lineheight,
          d.fontColor ? d.fontColor : defaultTextStyles.fontColor,
          d.fontSize ? d.fontSize : defaultTextStyles.fontSize,
          d.textAlign ? d.textAlign : defaultTextStyles.textAlign
        );
      }
      j += 1;
    });
    return ctx;
  };

  function textUnderline(context, text, x, y, color, textSize, align) {
    var textWidth = context.measureText(text).width;
    var startX = 0;
    var startY = y + parseInt(textSize) / 15 + 2;
    var endX = 0;
    var endY = startY;
    var underlineHeight = parseInt(textSize) / 15;

    if (underlineHeight < 1) {
      underlineHeight = 1;
    }

    context.beginPath();
    if (align === "center") {
      startX = x - textWidth / 2;
      endX = x + textWidth / 2;
    } else if (align === "right") {
      startX = x - textWidth;
      endX = x;
    } else {
      startX = x;
      endX = x + textWidth;
    }

    context.lineWidth = underlineHeight;
    context.moveTo(startX, startY);
    context.lineTo(endX, endY);
    context.strokeStyle = color;
    context.stroke();
  }

  function wrapText(context, text, x, y, maxWidth, lineHeight) {
    var words = text.split(" ");
    var line = "";
    for (var n = 0; n < words.length; n++) {
      var testLine = line + words[n] + " ";
      var metrics = context.measureText(testLine);
      var testWidth = metrics.width;
      if (testWidth > maxWidth) {
        context.fillText(line, x, y);
        line = words[n] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    context.fillText(line, x, y);
  }

  // to clear the search results after possible evidences menu closes
  useEffect(() => {
    if (isPossibleEvidenceModalClose && docViewer)
      docViewer.clearSearchResults();
  }, [docViewer, isPossibleEvidenceModalClose]);

  useEffect(() => {
    if (searchPayload && searchPayload.length > 0 && docViewer)
      searchHighlight(searchPayload, docViewer);
    else if (searchPayload === null && docViewer)
      docViewer.clearSearchResults();
  }, [searchPayload]);

  useEffect(() => {
    if (docViewer) {
      docViewer.clearSearchResults();
      if (
        selectedGroupEnhancedSearch &&
        selectedGroupEnhancedSearch.length > 0
      ) {
        searchHighlight(selectedGroupEnhancedSearch, docViewer);
      }
    }
  }, [selectedGroupEnhancedSearch]);

  useEffect(() => {
    if (docViewer && selectedSearchResult) {
      let elt = resultSet.find((item) => item.id === selectedSearchResult);
      elt && docViewer.setActiveSearchResult(elt);
    }
  }, [selectedSearchResult]);

  useEffect(() => {
    if (docViewer && selectedEnhancedSearch) {
      let elt = resultSet.find(
        (item) => item.id === selectedEnhancedSearch?.id
      );
      docViewer.setActiveSearchResult(elt);
    }
  }, [selectedEnhancedSearch]);

  useEffect(() => {
    if (docViewer && selectedReconciliation) {
      docViewer.clearSearchResults();
      var reconciliationHighlight = createSearchSet(
        selectedReconciliation?.quads,
        selectedReconciliation?.page_no,
        selectedReconciliation?.sheet_number,
        selectedReconciliation?.sheet_name,
        docViewer.getCompleteRotation(selectedReconciliation?.page_no),
        docViewer
      );
      docViewer.displayAdditionalSearchResult(reconciliationHighlight);
      docViewer.setActiveSearchResult(reconciliationHighlight);
    } else if (selectedReconciliation === null && docViewer) {
      docViewer.clearSearchResults();
    }
  }, [selectedReconciliation]);

  useEffect(() => {
    if (isReconciliationSidebarOpen && docViewer) {
      docViewer.clearSearchResults();
    }
  }, [isReconciliationSidebarOpen]);

  function _onMessageWasSent(message) {
    //Call API to store in server.
    message = _sendMessage(message);
    setFeedbackList([...feedbackList, message]);
  }

  function _sendMessage(message) {
    //Add extra data
    var canvasHolder = docViewer.getScrollViewElement();
    //FocusX/Y is of no use when moving around
    //Scroll positions only can help us find what user was looking at.
    // replaced the older scroll dimension with client as whole pdf is available with scroll
    message = {
      ...message,
      scale: docViewer.getZoom(),
      page: docViewer.getCurrentPage(),
      scrollTop: canvasHolder.clientTop,
      scrollLeft: canvasHolder.clientLeft,
      scrollHeight: canvasHolder.clientHeight,
      scrollWidth: canvasHolder.clientWidth,
      elementId: selectedAnnotation || 0,
    };
    let apiData = {
      jobId: jobId,
      type: viewType,
      metadata: JSON.stringify(message),
    };
    message.createdDate = new Date().getTime();
    addFeedback(apiData);
    return message;
  }

  useEffect(() => {
    setFeedbackList(feedback);
  }, [feedback]);

  const fromSupportingDocStamping = (supportDocStampLS) => {
    stampEndorsementStarted();
    setViewType("annotated");
    setTimeout(function () {
      setSelectedStampDocument(supportDocStampLS);
    }, 0);
    localStorage.removeItem("supportingStamp");
  };

  useEffect(() => {
    if (selectedStampDocument && stampMultiAnnot?.context?.annotation) {
      stampEndorsementStarted();
      let stampAnnot = null;
      let userInput;
      const jsonStampMetaData = JSON.parse(
        selectedStampDocument?.stampMetaData
      );
      if (jsonStampMetaData) {
        const { showPrompt, userVariableDisplayName } = jsonStampMetaData;
        if (showPrompt) {
          userInput = prompt(`${userVariableDisplayName}`);
        }
      }
      const totalPage = docViewer.getPageCount();
      //To check for stamping all pages or custom pages
      let iterArray;
      if (selectedStampDocument?.currentPageFlag) {
        iterArray = [docViewer.getCurrentPage()];
      } else if (selectedStampDocument?.customPageStampingArray) {
        iterArray = selectedStampDocument?.customPageStampingArray;
      } else {
        iterArray = Array.from({ length: totalPage }, (_, i) => i + 1);
      }
      for (let i = 0; i < iterArray.length; i++) {
        instance.Core.Tools.GenericAnnotationCreateTool.prototype.mouseLeftDown.call(
          stampMultiAnnot.context,
          stampMultiAnnot.e
        );

        const rotation = docViewer.getCompleteRotation(iterArray[i]);
        stampAnnot = stampMultiAnnot.context.annotation;

        stampAnnot.PageNumber = iterArray[i];
        stampAnnot.Rotation = docViewer.getCompleteRotation(iterArray[i]) * 90;
        if (rotation === 0 || rotation === 2) {
          stampAnnot.Width = selectedStampDocument.stampWidth;
          stampAnnot.Height = selectedStampDocument.stampHeight;
        } else if (rotation === 1 || rotation === 3) {
          stampAnnot.Width = selectedStampDocument.stampHeight;
          stampAnnot.Height = selectedStampDocument.stampWidth;
        }

        const keepAsSVG = false;
        if (selectedStampDocument.stampMetaData) {
          const c = document.createElement("canvas");
          const ctx = c.getContext("2d");
          c.height = selectedStampDocument.stampHeight;
          c.width = selectedStampDocument.stampWidth;
          createDynamicStamp(
            ctx,
            selectedStampDocument.stampWidth,
            selectedStampDocument.stampHeight,
            JSON.parse(selectedStampDocument.stampMetaData),
            userInput ? userInput : ""
          );
          stampAnnot.setImageData(c.toDataURL(), keepAsSVG);
        } else {
          stampAnnot.setImageData(selectedStampDocument.url, keepAsSVG);
        }
        stampAnnot.Author = annotManager.getCurrentUser();

        instance.Core.Tools.GenericAnnotationCreateTool.prototype.mouseLeftUp.call(
          stampMultiAnnot.context,
          stampMultiAnnot.e
        );

        // draw annotation
        instance.Core.documentViewer
          .getAnnotationManager()
          .redrawAnnotation(stampAnnot);
      }

      stampEndorsementSuccess();
      setSelectedStampDocument(null);
      setStampMultiAnnot(null);
      // to deselect the stampTool
      instance.UI.setToolMode("AnnotationEdit");
      // to select the last drawn stamp
      annotManager.selectAnnotation(stampAnnot);
    }
  }, [stampMultiAnnot, selectedStampDocument]);

  useEffect(() => {
    if (selectedFavAnnotId && freeTextAnnot) {
      instance.Core.Tools.GenericAnnotationCreateTool.prototype.mouseLeftDown.call(
        freeTextAnnot.context,
        freeTextAnnot.e
      );

      const freeTextAnnotation = freeTextAnnot.context.annotation;
      if (freeTextAnnotation) {
        const currentAnnot = annotationPayload.filter(
          (annotation) => annotation.id === selectedFavAnnotId
        )[0];
        const xfdfString = parser.parseFromString(
          currentAnnot.xfdf,
          "text/xml"
        );

        instance.Core.Tools.GenericAnnotationCreateTool.prototype.mouseLeftUp.call(
          freeTextAnnot.context,
          freeTextAnnot.e
        );

        // setting too to edit mode to deselect the freetext tool
        instance.UI.setToolMode("AnnotationEdit");

        annotManager.importAnnotCommand(xfdfString).then((data) => {
          let favAnnotData = data[0];
          // annotations generic properties
          freeTextAnnotation.Color = favAnnotData.Color;
          freeTextAnnotation.Rotation = favAnnotData.Rotation;
          freeTextAnnotation.Width = favAnnotData.Width;
          freeTextAnnotation.Height = favAnnotData.Height;
          freeTextAnnotation.Subject = favAnnotData.Subject;
          freeTextAnnotation.setContents(favAnnotData.getContents());
          freeTextAnnotation.selectionModel = favAnnotData.selectionModel;
          freeTextAnnotation.setRichTextStyle(favAnnotData.getRichTextStyle());
          // freetext annotation specific properties
          if (favAnnotData.intent === "FreeTextCallout") {
            // temp calculation
            let newPathArray = [...freeTextAnnotation.getPath()];
            let secondX = newPathArray[0].X + 100;
            let secondY = newPathArray[0].Y;
            let thirdX = secondX + 50;
            let thirdY = secondY + 50;
            let fourthX = thirdX + 10;
            let fourthY = thirdY - 25;
            let fifthX = fourthX + freeTextAnnotation.Width;
            let fifthY = fourthY + freeTextAnnotation.Height;

            freeTextAnnotation.setPathPoint(
              0,
              newPathArray[0].X,
              newPathArray[0].Y
            );
            freeTextAnnotation.setPathPoint(1, secondX, secondY);
            freeTextAnnotation.setPathPoint(2, thirdX, thirdY);
            freeTextAnnotation.setPathPoint(3, fourthX, fourthY);
            freeTextAnnotation.setPathPoint(4, fifthX, fifthY);
          }

          freeTextAnnotation.FontSize = favAnnotData.FontSize;
          freeTextAnnotation.TextColor = favAnnotData.TextColor;
          freeTextAnnotation.FillColor = favAnnotData.FillColor;
          freeTextAnnotation.setRect(favAnnotData.getRect());
          freeTextAnnotation.setIntent(favAnnotData.getIntent());
          freeTextAnnotation.setPadding(favAnnotData.getPadding());
          freeTextAnnotation.setStartStyle(favAnnotData.getStartStyle());
          freeTextAnnotation.StrokeThickness = favAnnotData.StrokeThickness;
          // draw annotation
          annotManager.addAnnotation(freeTextAnnotation, { autoFocus: false });
          annotManager.redrawAnnotation(freeTextAnnotation);
          // reset context and fav annotation selection
          setFreeTextAnnot(null);
          setSelectedFavAnnotId(null);
        });
      }
    }
  }, [selectedFavAnnotId, freeTextAnnot]);

  // to draw the restored annotation on pdf
  useEffect(() => {
    if (restoredAnnotationId) {
      let annotaionData = annotationPayload.filter(
        (annotation) => annotation.id === restoredAnnotationId
      );
      let xfdfData = annotaionData.length && annotaionData[0].xfdf;
      annotManager.importAnnotCommand(xfdfData).then((data) => {
        annotManager.drawAnnotationsFromList(data);
        // to highlight the restored annotation
        annotManager.deselectAllAnnotations();
        annotManager.jumpToAnnotation(data[0]);
        annotManager.selectAnnotation(data[0]);
        fullXFDFSetter(annotManager);
        setRestoredAnnotationId(null);
      });
    }
  }, [restoredAnnotationId]);

  // to remove the annotation from plan which is being deleted from left panel
  useEffect(() => {
    selectedAnnotationUuid && deleteAnnotFromPDF(selectedAnnotationUuid);
  }, [selectedAnnotationUuid]);

  // to highlight the annotation on plan which is selected from left panel
  useEffect(() => {
    let annotation =
      annotManager && annotManager.getAnnotationById(selectedAnnotation);
    if (annotManager && annotation) {
      annotManager.deselectAllAnnotations();
      annotManager.jumpToAnnotation(annotation);
      annotManager.selectAnnotation(annotation);
      // Need this delay to ensure all other event listeners fire before we show the line
      setTimeout(() => setShowLine(true), 300);
    }
  }, [annotManager, selectedAnnotation]);

  // useEffect(() => {
  //   if (docViewer && pageNumber && docViewer.getCurrentPage() !== pageNumber)
  //     docViewer.setCurrentPage(parseInt(pageNumber));
  // }, [docViewer, pageNumber]);

  // to make add annotation api call
  useEffect(() => {
    addedAnnotationString &&
      addAnnotation(jobId, addedAnnotationString, viewType);
  }, [addedAnnotationString]);

  // to make moidfy annotation api call
  useEffect(() => {
    viewType === "annotated" &&
      modifiedAnnotationString &&
      modifyAnnotation(jobId, modifiedAnnotationString, viewType);
  }, [modifiedAnnotationString]);

  // to make delete annotation api call for undo & redo
  useEffect(() => {
    if (deletedAnnotationString) {
      let annotaionData = annotationPayload.filter(
        (annotation) => annotation.annotationName === deletedAnnotationString
      );
      let id = annotaionData.length && annotaionData[0].id;
      if (id) {
        // api call
        discardRestoreAnnotation(jobId, id, viewType, true, "");
      }
    }
  }, [deletedAnnotationString]);

  // to delete annotation without popup - from delete icon, and onKeyPress
  useEffect(() => {
    if (open) {
      deleteAnnotation("", "");
    }
  }, [open]);

  useEffect(() => {
    fullXFDF && postFullAnnotationXfdf(jobId, viewType, fullXFDF);
  }, [fullXFDF]);

  useEffect(() => {
    if (instance && viewType) {
      instance.UI.loadDocument(
        API.DATATABLE_DOWNLOAD + "plan/" + jobId + "?download=original",
        {
          filename: "pdffile.pdf",
          customHeaders: {
            Authorization: localStorage.getItem(TOKEN_SESSION_ATTRIBUTE_NAME),
          },
        }
      );
    }
  }, [instance]);

  useEffect(() => {
    // getxfdfData && annotManager && annotManager.importAnnotations(getxfdfData);
    if (getxfdfData && annotManager) {
      const arrayXfdf = Object.entries(getxfdfData);
      arrayXfdf.forEach((item) => {
        annotManager.importAnnotations(item[1]);
      });
    }
  }, [annotManager, getxfdfData]);

  const deleteAnnotationsFromPDF = () => {
    // disable read only to delete the annotations
    annotManager.disableReadOnlyMode();
    const annots = annotManager.getAnnotationsList();
    annotManager.deleteAnnotations(annots);
  };

  useEffect(() => {
    if (annotManager && viewType && docViewer && instance) {
      deleteAnnotationsFromPDF();
      docViewer.clearSearchResults();
      if (viewType !== "basicPdfSearch" && viewType !== "enhancedSearch") {
        // annotation should be in read only mode for symbols and compliance view
        if (viewType === "annotated" && planStatus.toLowerCase() === "verify") {
          annotManager.disableReadOnlyMode();
          instance.UI.setToolbarGroup("toolbarGroup-Annotate");
        } else {
          annotManager.enableReadOnlyMode();
        }
        instance.setToolMode("Pan");
        // to get xfdf
        getFullAnnotationXfdf(jobId, viewType);
      } else {
        // to get annotated xfdf for search
        getFullAnnotationXfdf(jobId, "annotated");
        annotManager.enableReadOnlyMode();
      }
    }
  }, [annotManager, viewType, docViewer, instance]);

  //To handle the toggling of the fullscreen button and its functionality
  useEffect(() => {
    if (instance) {
      instance.UI.setHeaderItems(function (header) {
        header.getHeader("default").delete(24);
        var myCustomFullScreenButton = {
          type: "actionButton",
          title: `${fullScreenButton ? "Exit Full Screen" : "Full Screen"}`,
          dataElement: "fullscreenButton",
          onClick: function () {
            instance.UI.toggleFullScreen();
            setFullScreenButton(!fullScreenButton);
          },
          img: fullScreenButton
            ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - full screen - exit</title><path class="cls-1" d="M9.5,2H7V7H2V9.5H9.5ZM7,22H9.5V14.5H2V17H7Zm15-7.5H14.5V22H17V17h5ZM22,7H17V2H14.5V9.5H22Z"></path></svg>'
            : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - full screen</title><path class="cls-1" d="M4.22,4.22H9.78V2H2V9.78H4.22ZM9.78,19.78H4.22V14.22H2V22H9.78ZM22,14.22H19.78v5.56H14.22V22H22ZM19.78,9.78H22V2H14.22V4.22h5.56Z"></path></svg>',
        };
        header.push(myCustomFullScreenButton);
      });
    }
  }, [fullScreenButton, instance]);

  //To change the icon of fullscreen when escape key is pressed in fullscreen mode
  useEffect(() => {
    function handleFullScreenChange() {
      if (
        !document.fullscreenElement &&
        !document.webkitIsFullScreen &&
        !document.mozFullScreen &&
        !document.msFullscreenElement
      ) {
        setFullScreenButton(false);
      }
    }
    window.addEventListener("fullscreenchange", handleFullScreenChange);
    return () =>
      window.removeEventListener("fullscreenchange", handleFullScreenChange);
  }, [fullScreenButton]);

  //To handle the layouts of the pdftron manually as viewControlsOverlay is moved to header
  useEffect(() => {
    if (pageLayout && instance) {
      const LayoutMode = instance.UI.LayoutMode;
      if (pageTransition === "Pagebypage") {
        if (pageLayout === "SinglePage") {
          instance.UI.setLayoutMode(LayoutMode.Single);
        } else if (pageLayout === "DoublePage") {
          instance.UI.setLayoutMode(LayoutMode.Facing);
        }
      } else if (pageTransition === "Continuous") {
        if (pageLayout === "SinglePage") {
          instance.UI.setLayoutMode(LayoutMode.Continuous);
        } else if (pageLayout === "DoublePage") {
          instance.UI.setLayoutMode(LayoutMode.FacingContinuous);
        }
      }
    } else if (pageLayout === null && instance) {
      const LayoutMode = instance.UI.LayoutMode;
      if (pageTransition === "Pagebypage") {
        instance.UI.setLayoutMode(LayoutMode.Single);
      } else if (pageTransition === "Continuous") {
        instance.UI.setLayoutMode(LayoutMode.Continuous);
      }
    }
  }, [pageLayout, pageTransition]);

  useEffect(() => {
    if (viewType && instance) {
      instance.UI.setAnnotationContentOverlayHandler((annotation) => {
        const div = document.createElement("div");
        var boldElt = document.createElement("b");

        boldElt.appendChild(
          document.createTextNode(
            `${
              annotation.getCustomData("rule_index")
                ? annotation.getCustomData("rule_index")
                : "Manual"
            }`
          )
        );
        if (viewType !== "symbols") {
          div.appendChild(boldElt);
          div.appendChild(document.createElement("br"));
        }

        if (viewType === "symbols" || viewType === "annotated") {
          div.appendChild(
            document.createTextNode(`${annotation.getContents()}`)
          );
        } else {
          div.appendChild(
            document.createTextNode(`${annotation.getCustomData("message")}`)
          );
        }
        return div;
      });
    }
  }, [viewType, instance]);

  // to decide which icon to be shown in popup
  useEffect(() => {
    if (annotationUuid) {
      let state = "NotStarred";
      if (favouriteAnnotations.includes(annotationUuid)) state = "Starred";
      updateFuntion(state);
    }
  }, [annotationUuid]);

  // to make annotation as favourite
  useEffect(() => {
    if (annotationUuid && addRemoveFav) {
      let currentAnnot = annotationPayload.filter(
        (annotation) => annotation.annotationName === annotationUuid
      )[0];
      if (currentAnnot)
        makeAnnotationFavourite(addRemoveFav, jobId, currentAnnot.id);
      else toast.error(MESSAGE.FAVOURITEANNOTATION().FAILURE);
      setAddRemoveFav(null);
    }
  }, [addRemoveFav]);

  useEffect(() => {
    WebViewer(
      {
        licenseKey: PDFTRON_LICENSE_KEY,
        path: "/webviewer/lib",
        fullAPI: true,
        initialDoc: "",
        css: "/pdftron.css",
        useDownloader: false, // on true document linerization will be considered
        annotationAdmin: true, // When true any annotation within a document can be editted
        enableMeasurement: true,
      },
      viewer.current
    ).then(async (instance) => {
      const { Core, UI } = instance;
      const { documentViewer, annotationManager, Tools, Annotations } = Core;

      setInstance(instance);
      //dark mode configuration
      instance.setTheme("dark");
      //disabling pdftron inbuilt find feature (search overlay)
      instance.hotkeys.off(instance.hotkeys.Keys.COMMAND_F);
      instance.hotkeys.off(instance.hotkeys.Keys.CTRL_F);

      // to change the formatting for all distance measurement tool
      const distanceMeasurementTool = documentViewer.getTool(
        Tools.ToolNames.DISTANCE_MEASUREMENT
      );
      distanceMeasurementTool.enableImperialMarks();

      const distanceMeasurementTool2 = documentViewer.getTool(
        Tools.ToolNames.DISTANCE_MEASUREMENT2
      );
      distanceMeasurementTool2.enableImperialMarks();

      const distanceMeasurementTool3 = documentViewer.getTool(
        Tools.ToolNames.DISTANCE_MEASUREMENT3
      );
      distanceMeasurementTool3.enableImperialMarks();

      const distanceMeasurementTool4 = documentViewer.getTool(
        Tools.ToolNames.DISTANCE_MEASUREMENT4
      );
      distanceMeasurementTool4.enableImperialMarks();

      const iframeDoc = instance.UI.iframeWindow.document;
      const annotManager = annotationManager;
      if (localStorage.getItem("reviewerName")) {
        annotManager.setCurrentUser(localStorage.getItem("reviewerName"));
      } else if (localStorage.getItem("authenticatedUser")) {
        annotManager.setCurrentUser(localStorage.getItem("authenticatedUser"));
      }
      const docViewer = documentViewer;
      docViewer.setFitMode(docViewer.FitMode.FitWidth);
      docViewer.addEventListener("documentLoaded", () => {
        setDocViewer(docViewer);
        setAnnotation(Annotations);
        setAnnotManager(annotManager);
        const supportDocStampLS = JSON.parse(
          localStorage.getItem("supportingStamp")
        );
        if (supportDocStampLS) {
          fromSupportingDocStamping(supportDocStampLS);
        }
      });

      // to show tooltip inside polygon shapes
      Annotations.PolygonSelectionModel.prototype.testSelection = function (
        annotation,
        x,
        y,
        pageMatrix,
        zoom
      ) {
        return Annotations.SelectionAlgorithm.insidePolygonTest(
          annotation,
          x,
          y,
          pageMatrix,
          zoom
        );
      };

      // to show tooltip inside rectangle and ellipse
      const originalTestSelection =
        Annotations.BoxSelectionModel.prototype.testSelection;
      Annotations.BoxSelectionModel.prototype.testSelection = function (
        annotation,
        x,
        y
      ) {
        if (
          annotation instanceof Annotations.RectangleAnnotation ||
          Annotations.EllipseAnnotation
        ) {
          return Annotations.SelectionAlgorithm.boundingRectTest(
            annotation,
            x,
            y,
            documentViewer.getZoom()
          );
        }
        return originalTestSelection.apply(this, arguments);
      };

      annotManager.addEventListener(
        "annotationSelected",
        (annotations, action) => {
          const annotation = annotations[0];
          if (action === "selected") {
            setAnnotationUuid(annotation.Id);
          } else if (action === "deselected") {
            setAnnotationUuid(null);
          }

          // to hide/show favorite icon in popup
          if (
            action === "selected" &&
            annotation instanceof Annotations.FreeTextAnnotation
          ) {
            instance.enableElement("favouriteButton");
          } else {
            instance.disableElement("favouriteButton");
          }
        }
      );

      annotManager.addEventListener(
        "annotationChanged",
        (annotations, action, { imported, isUndoRedo, source }) => {
          // If annotation change is from import, return
          if (imported) {
            return;
          }

          annotManager.exportAnnotCommand().then((xfdfString) => {
            // prevents measurement annotation to be saved to DB
            const xmlDoc = parser.parseFromString(xfdfString, "text/xml");
            let MeasureAnnotation = xmlDoc.getElementsByTagName("measure")[0];
            let addDataExists = xmlDoc
              .getElementsByTagName("add")[0]
              .hasChildNodes();

            if (!MeasureAnnotation)
              if (action === "add" && addDataExists) {
                setAddedAnnotationString(xfdfString);
                fullXFDFSetter(annotManager);
              } else if (action === "modify") {
                setModifiedAnnotationString(xfdfString);
                fullXFDFSetter(annotManager);
              } else if (isUndoRedo && action === "delete") {
                setDeletedAnnotationString(annotations[0].Id);
                fullXFDFSetter(annotManager);
              }
          });
        }
      );

      docViewer.addEventListener("pageNumberUpdated", (pageNumber) => {
        handleURLChange({ pageNumber });
      });

      docViewer.addEventListener("zoomUpdated", (zoom) => {
        setZoomLevel(zoom);
      });

      // to remove line on pdf click
      docViewer.addEventListener("click", () => {
        showLine && setShowLine(false);
      });

      // to remove line on pdf scroll
      const documentContainer = iframeDoc.querySelector(
        '[data-element="documentContainer"]'
      );
      documentContainer.addEventListener("scroll", () => {
        setShowLine(false);
      });

      // to remove line on header click
      const header = iframeDoc.querySelector('[data-element="header"]');
      header.addEventListener("click", () => {
        setShowLine(false);
      });

      // customzing the delete annotation button
      UI.updateElement("annotationDeleteButton", {
        onClick: () => {
          //IMPORTANT: For now this will delete's only one annotation, should write a loop to delete multiple
          let annotation = annotManager.getSelectedAnnotations()[0];
          if (!annotation.Measure) getAnnotation();
          // No prompt on measurement
          else annotManager.deleteAnnotation(annotation);
        },
      });

      // In-case you wish to ever re-instate the original keyDown behavior within the same instance of WebViewer
      const originalKeyDown = Tools.AnnotationSelectTool.prototype.keyDown;

      Tools.AnnotationSelectTool.prototype.keyDown = function (e) {
        // if (e.which === 46 || e.which === 8) { //46- Delete, 8- Backspace
        if (e.which === 46) {
          e.preventDefault();
          let annotation = annotManager.getSelectedAnnotations()[0];
          if (annotation) {
            !annotManager.isReadOnlyModeEnabled() && getAnnotation();
          }
          return;
        }
        //originalMouseMove.apply(this, arguments);
      };

      //Toolbar Customization
      instance.UI.setHeaderItems(function (header) {
        const items = header.getItems();

        //Bringing the viewControlsOverlay to pdftron header
        items.splice(
          2,
          1,
          {
            type: "statefulButton",
            initialState: "continuousPageTransition",
            states: {
              continuousPageTransition: {
                title: "Continuous Page",
                img:
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page transition - continuous page - line</title><path class="cls-1" d="M20,2V9a2,2,0,0,1-2,2H6A2,2,0,0,1,4,9V2H6V9H18V2Zm0,17.94s0,0,0,.06v2H18V21H13a1,1,0,0,1-1-1V15H6v7H4V15a2,2,0,0,1,2-2h7.06l.26.05.09,0a1.17,1.17,0,0,1,.3.19l6,6a1.17,1.17,0,0,1,.19.3.36.36,0,0,1,0,.09A2,2,0,0,1,20,19.94Z"></path></svg>',
                onClick: () => {
                  setPageTransition("Continuous");
                },
              },
              defaultPageTransition: {
                title: "Page by Page",
                img:
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page transition - page by page - line</title><path class="cls-1" d="M17,17V7.83s0,0,0,0a1.7,1.7,0,0,0,0-.22l0-.07a.82.82,0,0,0-.16-.25l-5-5a.82.82,0,0,0-.25-.16l-.08,0-.21,0H5.34A1.67,1.67,0,0,0,3.67,3.67V17a1.67,1.67,0,0,0,1.67,1.67h10A1.67,1.67,0,0,0,17,17ZM5.67,4h4.66V7.83a.84.84,0,0,0,.84.83H15v8H5.67ZM20.33,9.51V20.33A1.67,1.67,0,0,1,18.66,22H11.17V20h7.16V9.51Z"></path></svg>',
                onClick: () => {
                  setPageTransition("Pagebypage");
                },
              },
            },
            mount: (update) => {
              const pageTransitionState = (pageTrans) => {
                // the returned state should be the opposite of the new current state
                // as the opposite state is what we want to switch to when the button
                // is clicked next
                if (
                  instance.UI.getLayoutMode() === "Continuous" ||
                  instance.UI.getLayoutMode() === "FacingContinuous"
                ) {
                  return "defaultPageTransition";
                } else if (
                  instance.UI.getLayoutMode() === "Single" ||
                  instance.UI.getLayoutMode() === "Facing"
                ) {
                  return "continuousPageTransition";
                }
              };

              docViewer.addEventListener(
                "displayModeUpdated.dualPageTransitionButton",
                (layoutMode) => {
                  update(pageTransitionState(layoutMode));
                }
              );
            },
            unmount: () => {
              docViewer.removeEventListener(
                "displayModeUpdated.dualPageTransitionButton"
              );
            },
            dataElement: "dualPageTransitionButton",
          },
          {
            type: "actionButton",
            title: "Rotate Clockwise",
            dataElement: "rotateClockwiseButton",
            onClick: function () {
              docViewer.rotateClockwise();
            },
            img:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page rotation - clockwise - line</title><path class="cls-1" d="M22,7.83,18.67,12,15.33,7.83h2.43a5,5,0,0,0-4.93-4.16V2a6.64,6.64,0,0,1,6.61,5.83ZM14,12.2s0,0,0,.05V20.5A1.5,1.5,0,0,1,12.5,22h-9A1.5,1.5,0,0,1,2,20.5V8.5A1.5,1.5,0,0,1,3.5,7H8.8a.65.65,0,0,1,.19,0l.07,0a.86.86,0,0,1,.22.15l4.5,4.5a.66.66,0,0,1,.15.22s0,.05,0,.07A.65.65,0,0,1,14,12.2ZM12,20V13H8.75A.76.76,0,0,1,8,12.25V9H4V20Z"></path></svg>',
          },
          {
            type: "actionButton",
            title: "Rotate Counterclockwise",
            dataElement: "rotateCounterClockwiseButton",
            onClick: function () {
              docViewer.rotateCounterClockwise();
            },
            img:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page rotation - counterclockwise - line</title><path class="cls-1" d="M22.39,11.17H20.72a5,5,0,0,0-4.17-4.93V8.67L12.39,5.33,16.55,2V4.56a6.66,6.66,0,0,1,5.84,6.61Zm-8,1s0,0,0,.05V20.5a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5V8.5A1.5,1.5,0,0,1,3.89,7H9.18a.71.71,0,0,1,.2,0l.07,0a1.07,1.07,0,0,1,.22.15l4.5,4.5a.86.86,0,0,1,.15.22.19.19,0,0,0,0,.07A1.29,1.29,0,0,1,14.38,12.2Zm-2,7.8V13H9.14a.75.75,0,0,1-.75-.75V9h-4V20Z"></path></svg>',
          },
          {
            type: "statefulButton",
            initialState: "singleLayout",
            states: {
              singleLayout: {
                title: "Single Page",
                img:
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page layout - single page - line</title><path class="cls-1" d="M20,8.94a2,2,0,0,0,0-.26.36.36,0,0,0,0-.09,1.17,1.17,0,0,0-.19-.3l-6-6a1.17,1.17,0,0,0-.3-.19l-.09,0L13.06,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V9S20,9,20,8.94ZM6,20V4h6V9a1,1,0,0,0,1,1h5V20Z"></path></svg>',
                onClick: () => {
                  setPageLayout("SinglePage");
                },
              },
              doubleLayout: {
                title: "Double Page",
                img:
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - page manipulation - page layout - double page - line</title><path class="cls-1" d="M11,10.13s0,0,0-.05a1,1,0,0,0-.11-.17L7.46,6.54a.57.57,0,0,0-.16-.11l-.06,0-.14,0h-4A1.12,1.12,0,0,0,2,7.5v9a1.12,1.12,0,0,0,1.13,1.12H9.88A1.12,1.12,0,0,0,11,16.5V10.28A.4.4,0,0,0,11,10.13ZM3.13,16.5v-9H6.5v2.81a.57.57,0,0,0,.56.57H9.88V16.5ZM22,10.28a.4.4,0,0,0,0-.15s0,0,0-.05a1,1,0,0,0-.11-.17L18.46,6.54a.57.57,0,0,0-.16-.11l-.06,0-.14,0h-4A1.12,1.12,0,0,0,13,7.5v9a1.12,1.12,0,0,0,1.13,1.12h6.74A1.12,1.12,0,0,0,22,16.5V10.28ZM14.13,16.5v-9H17.5v2.81a.57.57,0,0,0,.56.57h2.81V16.5Z"></path></svg>',
                onClick: () => {
                  setPageLayout("DoublePage");
                },
              },
            },
            mount: (update) => {
              const pageLayoutState = (pageTrans) => {
                // the returned state should be the opposite of the new current state
                // as the opposite state is what we want to switch to when the button
                // is clicked next
                if (
                  instance.UI.getLayoutMode() === "Continuous" ||
                  instance.UI.getLayoutMode() === "Single"
                ) {
                  return "doubleLayout";
                } else if (
                  instance.UI.getLayoutMode() === "Facing" ||
                  instance.UI.getLayoutMode() === "FacingContinuous"
                ) {
                  return "singleLayout";
                }
              };

              docViewer.addEventListener(
                "displayModeUpdated.dualPageLayoutButton",
                (layoutMode) => {
                  update(pageLayoutState(layoutMode));
                }
              );
            },
            unmount: () => {
              docViewer.removeEventListener(
                "displayModeUpdated.dualPageLayoutButton"
              );
            },
            dataElement: "dualPageLayoutButton",
          }
        );

        //Bringing the toolbarGroup-Shapes to pdftron header
        items.splice(
          9,
          1,
          {
            type: "divider",
          },
          {
            type: "toolGroupButton",
            toolGroup: "freeHandTools",
            title: "annotation.freehand",
            dataElement: "freeHandToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "freeHandHighlightTools",
            title: "annotation.freeHandHighlight",
            dataElement: "freeHandHighlightToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "rectangleTools",
            title: "annotation.rectangle",
            dataElement: "shapeToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "ellipseTools",
            title: "annotation.ellipse",
            dataElement: "ellipseToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "polygonTools",
            title: "annotation.polygon",
            dataElement: "polygonToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "cloudTools",
            title: "annotation.polygonCloud",
            dataElement: "polygonCloudToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "lineTools",
            title: "annotation.line",
            dataElement: "lineToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "polyLineTools",
            title: "annotation.polyline",
            dataElement: "polyLineToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "arrowTools",
            title: "annotation.arrow",
            dataElement: "arrowToolGroupButton",
          }
        );

        header.update(items);

        // Deleting all icon except FreeText from annotate and add at the end
        header
          .getHeader("toolbarGroup-Annotate")
          .delete("highlightToolGroupButton");
        header
          .getHeader("toolbarGroup-Annotate")
          .delete("underlineToolGroupButton");
        header
          .getHeader("toolbarGroup-Annotate")
          .delete("strikeoutToolGroupButton");
        header
          .getHeader("toolbarGroup-Annotate")
          .delete("squigglyToolGroupButton");
        header
          .getHeader("toolbarGroup-Annotate")
          .delete("shapeToolGroupButton");
        header
          .getHeader("toolbarGroup-Annotate")
          .delete("freeHandToolGroupButton");
        header
          .getHeader("toolbarGroup-Annotate")
          .delete("freeHandHighlightToolGroupButton");

        //Bringing all icons together in toolbarGroup-Annotate
        header.getHeader("toolbarGroup-Annotate").push(
          //Insert
          {
            type: "actionButton",
            title: "Rubber Stamp",
            img: stampIcon,
            onClick: () => {
              setStampTabActive(true);
              setIsStampModalOpen(true);
            },
            dataElement: "stampAnnotation",
          },
          {
            type: "actionButton",
            title: "Favorite Annotation",
            img: favouriteIcon,
            onClick: () => {
              setStampTabActive(false);
              setIsStampModalOpen(true);
            },
            dataElement: "favAnnotation",
          },
          {
            type: "toolGroupButton",
            toolGroup: "signatureTools",
            title: "annotation.signature",
            dataElement: "signatureToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "calloutTools",
            title: "annotation.callout",
            dataElement: "calloutToolGroupButton",
          },
          //Measurement
          {
            type: "toolGroupButton",
            toolGroup: "distanceTools",
            title: "annotation.distanceMeasurement",
            dataElement: "distanceToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "perimeterTools",
            title: "annotation.perimeterMeasurement",
            dataElement: "perimeterToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "areaTools",
            title: "annotation.areaMeasurement",
            dataElement: "areaToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "ellipseAreaTools",
            title: "annotation.areaMeasurement",
            dataElement: "ellipseAreaToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "rectangleAreaTools",
            title: "annotation.areaMeasurement",
            dataElement: "rectangleAreaToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "cloudyRectangleAreaTools",
            title: "annotation.areaMeasurement",
            dataElement: "cloudyRectangleAreaToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "countTools",
            title: "annotation.countMeasurement",
            dataElement: "countToolGroupButton",
          },
          //Annotate
          {
            type: "toolGroupButton",
            toolGroup: "highlightTools",
            title: "annotation.highlight",
            dataElement: "highlightToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "underlineTools",
            title: "annotation.underline",
            dataElement: "underlineToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "strikeoutTools",
            title: "annotation.strikeout",
            dataElement: "strikeoutToolGroupButton",
          },
          {
            type: "toolGroupButton",
            toolGroup: "squigglyTools",
            title: "annotation.squiggly",
            dataElement: "squigglyToolGroupButton",
          }
        );
      });

      //disbling certain elements from pdftron
      UI.disableElements([
        "ribbons",
        "menuButton",
        "linkButton",
        "printButton",
        "thumbDelete",
        "searchButton",
        "downloadButton",
        "textSelectButton",
        "selectToolButton",
        "thumbMultiDelete",
        "themeChangeButton",
        "toggleNotesButton",
        "toolbarGroup-Edit",
        "toolbarGroup-Forms",
        "outlinesPanelButton",
        "toolbarGroup-Insert",
        "toolbarGroup-Shapes",
        "toolbarGroup-Measure",
        "stickyToolGroupButton",
        "annotationCommentButton",
        "toolbarGroup-FillAndSign",
      ]);

      // adding favorite button to annotation popup
      const favButton = {
        type: "statefulButton",
        initialState: "NotStarred",
        states: {
          NotStarred: {
            img: favouriteIcon,
            onClick: (update) => {
              setAddRemoveFav("post");
              update("Starred");
            },
          },
          Starred: {
            img: favouriteMarked,
            onClick: (update) => {
              setAddRemoveFav("delete");
              update("NotStarred");
            },
          },
        },
        mount: (update) => {
          // to update stateful button's state dynamically,
          // storing `update` function to global variable
          updateFuntion = update;
        },
        dataElement: "favouriteButton",
      };

      const annotationPopupItems = instance.UI.annotationPopup.getItems();
      instance.UI.annotationPopup.add(
        favButton,
        annotationPopupItems[annotationPopupItems.length - 1].dataElement
      );

      docViewer.getTool("AnnotationCreateRectangle").setStyles({
        StrokeThickness: 2,
        StrokeColor: new Annotations.Color(255, 0, 0),
      });

      docViewer.getTool("AnnotationCreateCallout").setStyles({
        Border: 0,
        StrokeThickness: 0,
        StrokeColor: new Annotations.Color(255, 0, 0),
        TextColor: new Annotations.Color(255, 0, 0),
        FontSize: "20pt",
      });

      /**
       * Logic to add stamps to exiting standard stamp list
       */
      const tool = docViewer.getTool("AnnotationCreateRubberStamp");
      let stamps = await getStandardStamps(jobId);
      let jurisdictionStamps;
      if (stamps) {
        jurisdictionStamps = stamps.map((d) =>
          API_CONFIG.API_ROOT.concat(d.url)
        );
        tool.setStandardStamps([...jurisdictionStamps]);
      }

      tool.setCustomDrawFunction((ctx, annotation) => {
        const originalUrl = annotation.getCustomData("trn-original-url");
        const stamp = stamps.find(
          (d) => API_CONFIG.API_ROOT.concat(d.url) === originalUrl
        );
        if (stamp?.stampMetadata) {
          let userInput;
          const jsonStampMetaData = JSON.parse(stamp.stampMetadata);
          const { showPrompt, userVariableDisplayName } = jsonStampMetaData;
          if (showPrompt) {
            userInput = prompt(`${userVariableDisplayName}`);
          }
          createDynamicStamp(
            ctx,
            annotation.Width,
            annotation.Height,
            jsonStampMetaData,
            userInput ? userInput : ""
          );
        }
      });

      const CustomStampCreateTool = function (docViewer) {
        Tools.GenericAnnotationCreateTool.call(
          this,
          docViewer,
          Annotations.StampAnnotation
        );
      };
      CustomStampCreateTool.prototype = new Tools.GenericAnnotationCreateTool();

      CustomStampCreateTool.prototype.mouseLeftDown = function () {
        Tools.AnnotationSelectTool.prototype.mouseLeftDown.apply(
          this,
          arguments
        );
      };
      CustomStampCreateTool.prototype.mouseMove = function () {
        Tools.AnnotationSelectTool.prototype.mouseMove.apply(this, arguments);
      };
      CustomStampCreateTool.prototype.mouseLeftUp = function (e) {
        Tools.GenericAnnotationCreateTool.prototype.mouseLeftDown.call(this, e);
        setStampMultiAnnot({ context: this, e });
      };

      const stampTool = new CustomStampCreateTool(instance.Core.documentViewer);
      instance.UI.registerTool({
        toolObject: stampTool,
        toolName: stampToolName,
        buttonName: "anything",
      });

      // tool to create free text annottaion dynamically
      const CustomFreeTextCreateTool = function (docViewer) {
        Tools.GenericAnnotationCreateTool.call(
          this,
          docViewer,
          Annotations.FreeTextAnnotation
        );
      };
      CustomFreeTextCreateTool.prototype = new Tools.GenericAnnotationCreateTool();
      CustomFreeTextCreateTool.prototype.mouseLeftDown = function () {
        Tools.AnnotationSelectTool.prototype.mouseLeftDown.apply(
          this,
          arguments
        );
      };
      CustomFreeTextCreateTool.prototype.mouseMove = function () {
        Tools.AnnotationSelectTool.prototype.mouseMove.apply(this, arguments);
      };
      CustomFreeTextCreateTool.prototype.mouseLeftUp = function (e) {
        Tools.GenericAnnotationCreateTool.prototype.mouseLeftDown.call(this, e);
        setFreeTextAnnot({ context: this, e });
      };
      const freeTextTool = new CustomFreeTextCreateTool(
        instance.Core.documentViewer
      );
      instance.UI.registerTool({
        toolObject: freeTextTool,
        toolName: freeTextToolName,
        buttonName: "freeTextTool",
      });
    });
  }, []);

  // It renders plan.
  return (
    <div
      className={`landing-pdf-container ${
        isPdfSelected ? "pdf-visibility-enable" : "pdf-visibility-disable"
      }`}
      ref={pdfViewerRef}
    >
      <div className="webviewer webViewerHeight" ref={viewer}>
        {isSidebarOpen && selectedAnnotation && (
          <SidebarToAnnotationLine
            showLine={showLine}
            docViewer={docViewer}
            zoomLevel={zoomLevel}
            sidebarRef={sidebarRef}
            setShowLine={setShowLine}
            pdfViewerRef={pdfViewerRef}
            annotationRefs={annotationRefs}
            selectedAnnotation={selectedAnnotation}
          />
        )}
      </div>
      {/* <DiscardReasonModal
        isModalOpen={open}
        handleClose={handleClose}
        //annotationName={annotationName}
        handleDiscardAnnotation={deleteAnnotation}
      /> */}
      {isStampModalOpen && (
        <StampModalComponent
          jobId={jobId}
          instance={instance}
          stampToolName={stampToolName}
          freeTextToolName={freeTextToolName}
          isStampModalOpen={isStampModalOpen}
          pdfPages={docViewer.getPageCount()}
          setIsStampModalOpen={setIsStampModalOpen}
          setSelectedStampDocument={setSelectedStampDocument}
          stampTabActive={stampTabActive}
          setStampTabActive={setStampTabActive}
          selectedFavAnnotId={selectedFavAnnotId}
          setSelectedFavAnnotId={setSelectedFavAnnotId}
        />
      )}
      <FadeLoader
        css={override}
        height={15}
        width={5}
        radius={2}
        margin={2}
        color={"#4183C5"}
        loading={loading || stampendorsementLoading}
      />
      {isPdfSelected && (
        <Launcher
          agentProfile={{
            teamName: "Feedback",
          }}
          onMessageWasSent={_onMessageWasSent}
          messageList={feedbackList}
          showEmoji={false}
          mute={true}
          launcherPosition={isPdfSelected && isDocumentSelected}
        />
      )}
    </div>
  );
};

const mapStatetoProps = (state) => ({
  loading: state.landing.loading,
  annotationPayload: state.verification.annotationPayload,
  searchPayload: state.verification.searchResults,
  feedback: state.verification.feedback,
  getxfdfData: state.landing.getxfdfData,
  favouriteAnnotations: state.verification.favouriteAnnotations,
  stampendorsementLoading: state.verification.stampendorsementLoading,
  isPossibleEvidenceModalClose: state.landing.isPossibleEvidenceModalClose,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    addAnnotation: (jobId, xfdfString, viewType) => {
      dispatch(addAnnotation(jobId, xfdfString, viewType));
    },
    modifyAnnotation: (jobId, xfdfString, viewType) => {
      dispatch(modifyAnnotation(jobId, xfdfString, viewType));
    },
    postFullAnnotationXfdf: (jobId, viewType, xfdfString) => {
      dispatch(postFullAnnotationXfdf(jobId, viewType, xfdfString));
    },
    getFullAnnotationXfdf: (jobId, viewType) => {
      dispatch(getFullAnnotationXfdf(jobId, viewType));
    },
    discardRestoreAnnotation: (
      jobId,
      annotationId,
      type,
      isDiscarded,
      reasonForDiscard
    ) => {
      dispatch(
        discardRestoreAnnotation(
          jobId,
          annotationId,
          type,
          isDiscarded,
          reasonForDiscard
        )
      );
    },
    stampEndorsementSuccess: () => {
      dispatch(stampEndorsementSuccess());
    },
    makeAnnotationFavourite: (method, jobId, annotationId) => {
      dispatch(favouriteAnnotation(method, jobId, annotationId));
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(PDFViewer);
